import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import moment from 'moment';
import get from 'lodash/get';
import React from 'react';
import StaticPicture from '../StaticImage';
import { Container, Description, NewsItemBottom } from './policy.card';

const PolicyCard = ({ policy, big, noContent }) => {
  const policySubTitle = get(policy, 'policyPostsFields.policySubTitle');
  const editedContent = policySubTitle
    ? policySubTitle.substring(0, 100)
    : null;
  const imgUrl = get(policy, 'featuredImage.node.mediaItemUrl');
  const imgAltText = get(policy, 'featuredImage.node.altText');
  const title = get(policy, 'title');
  const optimizeImage = get(policy, 'featuredImage.node.localFile');
  const authorNames = get(policy, 'policyPostsFields.policyAuthor');
  const date = get(policy, 'date');
  const editedDate = moment(date).format('MMMM D, YYYY');

  return (
    <Container className='com-policy-list-page' data-testid='policy-page-card'>
      <Link to={`/policies-and-actions/${policy && policy.slug}/`} title={title}>
        <figure>
          {optimizeImage ? (
            <GatsbyImage image={getImage(optimizeImage)} alt={imgAltText} />
          ) : (
            <StaticPicture imgFile={imgUrl} altText={imgAltText} size='m' />
          )}
        </figure>
      </Link>
      <Description big={big}>
        <h3>
          <Link to={`/policies-and-actions/${policy && policy.slug}/`} title={title}>
            {title}
          </Link>
        </h3>
        {!noContent ? (
          <div>
            <p>{editedContent}...</p>
          </div>
        ) : null}
        <NewsItemBottom>
          {authorNames &&
            Array.isArray(authorNames) &&
            authorNames.map((value, index) => (
              <span className='author-container' key={index}>
                <Link
                  to={`/author/${value.slug}/`}
                  className='author-name'
                  data-testid='author-name'
                  title={value.name}
                >
                  {value.name}
                </Link>
                {index !== authorNames.length - 1 && ', '}
              </span>
            ))}
          {authorNames && Array.isArray(authorNames) && authorNames.length > 0 && editedDate && <span className='divider' />}
          {editedDate && <span>{editedDate}</span>}
        </NewsItemBottom>
      </Description>
    </Container>
  );
};

export default PolicyCard;
